var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const Button = (_a) => {
    var { className = '', size = 'medium', color = 'primary', children } = _a, rest = __rest(_a, ["className", "size", "color", "children"]);
    const baseClass = 'inline-flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2';
    const sizeClass = size === 'small'
        ? 'px-3 py-1 text-sm font-medium rounded-md'
        : 'px-4 py-2 text-sm font-medium rounded-md';
    const colorClass = color === 'danger'
        ? 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-500'
        : color === 'success'
            ? 'bg-green-500 text-white hover:bg-green-600 focus:ring-green-500 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-500'
            : color === 'secondary'
                ? 'bg-gray-600 text-white hover:bg-gray-700 focus:ring-gray-500 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-400'
                : color === 'gray'
                    ? 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 focus:ring-gray-500 dark:focus:ring-gray-400'
                    : color === 'link'
                        ? 'text-blue-600 dark:text-blue-400 hover:text-blue-900 dark:hover:text-blue-300 focus:ring-blue-500 dark:focus:ring-blue-400'
                        : 'bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-500 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-400';
    return (_jsx("button", Object.assign({}, rest, { className: `${baseClass} ${sizeClass} ${colorClass} ${className}`, children: children })));
};
export { Button };
export default Button;
